export default {
  methods: {
    async deleteAlert(name) {
      const res = await this.$swal
        .fire({
          title: 'Weet u het zeker?',
          text: 'Deze actie kan niet worden terug gedraait!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: `Ja, Verwijder ${name}!`,
          cancelButtonText: 'Annuleer!'
        })
        .then(async result => {
          if (result.value) {
            this.$swal.fire('Verwijderd!', `Het ${name} is met succes verwijderd`, 'success')
            return 'deleted'
            // await this.$store.dispatch('deleteProject', project.projectId)
          }
        })
      return res
      // ask for new token to update claims
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rmBtnMixin.js